import { Box, Card, CardContent } from '@mui/material';
import { AutomatedEmailCampaignType } from 'wisestep-api';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import { ContactAutocomplete } from '../../../../components/ContactAutocomplete';
import { WsBreadCrumbs } from '../../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../../features/teams/helper/defaultValues';
import { CampaignLayout } from '../../components';
import { campaignHeaderHelper } from '../../utils';

export const ClientSpocCampaign = ({ disable }: { disable: boolean }) => (
  <>
    <WsBreadCrumbs
      breadCrumbsList={[
        ...getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.CRM,
          Pages['CLIENT_SPOC_AUTOMATED_EMAIL_CAMPAIGN']
        ),
        Pages['ADD_NEW_AUTOMATED_EMAIL_CAMPAIGN'],
      ]}
    />
    <Card>
      <CardContent sx={{ p: 3 }}>
        <CampaignLayout
          header={
            <Box display="flex" flexDirection="column" rowGap={1}>
              <WsTypography bold>{campaignHeaderHelper['clientContactId'].header}</WsTypography>
              <ContactAutocomplete
                name="clientContact"
                placeHolder=""
                required={true}
                disable={disable}
              />
              <WsTypography variant={WsTypoVariants.BODY1}>
                {campaignHeaderHelper['clientContactId'].subHeader}
              </WsTypography>
            </Box>
          }
          layoutType={AutomatedEmailCampaignType.CLIENT_SPOC}
        />
      </CardContent>
    </Card>
  </>
);
